var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.23 23.2598L24.69 22.9698C24.3914 22.9347 24.0886 22.9678 23.8046 23.0665C23.5206 23.1652 23.2626 23.327 23.05 23.5398L21.21 25.3798C18.3712 23.936 16.0638 21.6286 14.62 18.7898L16.47 16.9398C16.9 16.5098 17.11 15.9098 17.04 15.2998L16.75 12.7798C16.6933 12.2919 16.4592 11.842 16.0923 11.5156C15.7253 11.1892 15.2511 11.0092 14.76 11.0098H13.03C11.9 11.0098 10.96 11.9498 11.03 13.0798C11.56 21.6198 18.39 28.4398 26.92 28.9698C28.05 29.0398 28.99 28.0998 28.99 26.9698V25.2398C29 24.2298 28.24 23.3798 27.23 23.2598Z",
    fill: "#F4BA40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCall);
export default __webpack_public_path__ + "static/media/task_call.be0463665df02a98b98f75828f21d38e.svg";
export { ForwardRef as ReactComponent };